import { Injectable } from "@angular/core";
import { RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { tap } from 'rxjs/operators';
import { ChiefsOrderService } from "../../services/chiefsOrder.service";
import { LoaderService } from "../../common/services/loader.service";

@Injectable()
export class ChiefsOrderCoInProg  {
        
    constructor(public srv: ChiefsOrderService,
        public loaderService: LoaderService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        this.loaderService.toggleLoader(true);

        if (route.paramMap.get('coid'))
        {
            var coid = route.paramMap.get('coid')
            return this.srv.getlettercontents(coid).pipe(tap((data) => { this.loaderService.toggleLoader(false); }));
        }

    }

}